/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import {
  Avatar,
  Button,
  List,
  message,
  Popconfirm,
  Tooltip,
  Typography,
} from 'antd'

import { useCompanies } from '~/hooks/Companies/useCompanies'
import { useScale } from '~/hooks/Scales/useScale'
import { useLocale } from '~/hooks/locale/useLocale'

import api from '~/services/api'

import { ShowError } from '~/utils/errors/apiErrors'
import { translate } from '~/utils/locale'
import { DeleteOutlined, UserOutlined } from '@ant-design/icons'

const ScaleContributorsList: React.FC = () => {
  const [confirmLoading, setConfirmLoading] = useState(false)

  const { Title, Text } = Typography

  const { scaleId } = useParams<{ scaleId: string }>()

  const { selectedCompany } = useCompanies()
  const { scaleData, scaleRefetch } = useScale()
  const { locale } = useLocale()

  const handleDelete = async (id: string) => {
    try {
      setConfirmLoading(true)
      await api.delete(
        `/company/${selectedCompany}/schedule/${scaleId}/collaborator/${id}`,
      )
      setConfirmLoading(false)
      scaleRefetch()
      message.success(translate('ScalesContributorsList.successMessage'))
    } catch (err: any) {
      ShowError(
        err.message,
        translate('ScalesContributorsList.errorMessage'),
        locale,
      )

      setConfirmLoading(false)
    }
  }

  return (
    <List
      itemLayout="horizontal"
      size="large"
      dataSource={scaleData.contributorsSchedules}
      renderItem={(item) => (
        <List.Item
          key={item.id}
          actions={[
            <Tooltip
              title={translate('ScalesContributorsList.deleteTooltip')}
              key="DeleteTooltip"
            >
              <Popconfirm
                title={translate('ScalesContributorsList.deletePopconfirm')}
                onConfirm={() => handleDelete(item.collaborator.id)}
              >
                <Button
                  ghost
                  shape="circle"
                  icon={<DeleteOutlined />}
                  size="small"
                  loading={confirmLoading}
                  danger
                />
              </Popconfirm>
            </Tooltip>,
          ]}
        >
          <List.Item.Meta
            avatar={
              <Avatar
                icon={<UserOutlined />}
                style={{
                  color: '#fff',
                  background: '#3C8ACB',
                }}
              />
            }
            title={
              <Tooltip title="Ver Cliente">
                <Link
                  to={`/colaboradores/visualizar/colaborador/${item.collaborator?.id}/contato/${item.collaborator?.contact?.id}`}
                >
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Colaborador
                  </Title>
                </Link>
              </Tooltip>
            }
            description={<Text>{item.collaborator.contact.name}</Text>}
          />
        </List.Item>
      )}
    />
  )
}

export default ScaleContributorsList
